import React, { useState, useCallback } from "react";
import PropTypes from "prop-types";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TextField,
} from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import SaveIcon from "@material-ui/icons/Save";

const Onsite = (props) => {
  const { header, data, customerInvoice, updateInvoice, classes } = props;
  const serviceLabel = data.vat ? "VAT" : "Service Charges";
  let { id } = useParams();

  console.log(data);

  const [isEdit, setIsEdit] = useState(true);
  const toEditHandler = () => {
    setIsEdit(false);
  };

  const formValue = {
    _id: data?._id,
    totalAmount: data?.totalAmount,
    discounts: data?.discounts,
    subTotal: data?.subTotal?.toFixed(2),
    serviceChargePercent: data?.adminPercent,
    invTotal: data?.invTotal?.toFixed(2),
    advancePayment: data?.advancePayment,
  };
  console.log(formValue);

  const { register, handleSubmit, watch } = useForm({
    mode: "onChange",
    defaultValues: formValue,
  });

  const discountsWatch = watch("discounts");

  const subTotalAmount = useCallback(() => {
    let total = 0;
    let discount = parseFloat(discountsWatch) || 0;
    total = formValue?.totalAmount - discount;
    return total;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.total, discountsWatch, formValue]);

  const totalPercentage = useCallback(() => {
    let total = 0;
    total = parseFloat(
      (subTotalAmount() * formValue.serviceChargePercent) / 100,
    ); // eslint-disable-next-line react-hooks/exhaustive-deps
    return total;
  }, [subTotalAmount, formValue.serviceChargePercent]);

  const invTotal = useCallback(() => {
    let invTotal = 0.0;
    invTotal = totalPercentage() + subTotalAmount();
    return invTotal.toFixed(2);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.total, subTotalAmount]);

  const dueTotal = useCallback(() => {
    var advPayment = 0;
    var total = 0;

    advPayment = formValue.advancePayment || 0.0;
    total = invTotal() - advPayment;
    return total;
  }, [invTotal, formValue]);

  const onSubmit = async (data) => {
    // console.log(data)
    try {
      await updateInvoice(data, id);
      await setIsEdit(true);
    } catch (error) {
      console.log(error);
      await setIsEdit(false);
    }
  };

  return (
    <>
      <input
        type="hidden"
        value={formValue._id}
        ref={register}
        name="_id"
        readOnly
      />
      <TableContainer component={Paper}>
        <Table size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell className={header}>Description</TableCell>
              <TableCell className={header} align="right">
                Hours
              </TableCell>
              <TableCell className={header} align="right">
                Mins
              </TableCell>
              <TableCell className={header} align="right">
                Minimum rate per hour (£)
              </TableCell>
              <TableCell className={header} align="right">
                Amount (£)
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell component="th" scope="row">
                Attendance 1
              </TableCell>
              <TableCell align="right">
                {data.attendanceOneTotalDuration.split(":")[0]}
              </TableCell>
              <TableCell align="right">
                {data.attendanceOneTotalDuration.split(":")[1]}
              </TableCell>
              <TableCell align="right">
                {data.attendanceOneMinRate.toFixed(2)}
              </TableCell>
              <TableCell align="right">
                {data.totalAttendanceOneAmount.toFixed(2)}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell component="th" scope="row">
                Attendance 2
              </TableCell>
              <TableCell align="right">
                {data.attendanceTwoTotalDuration.split(":")[0]}
              </TableCell>
              <TableCell align="right">
                {data.attendanceTwoTotalDuration.split(":")[1]}
              </TableCell>
              <TableCell align="right">
                {data.attendanceTwoMinRate.toFixed(2)}
              </TableCell>
              <TableCell align="right">
                {data.totalAttendanceTwoAmount.toFixed(2)}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell component="th" scope="row">
                Travel Inward charges
              </TableCell>
              <TableCell align="right">
                {data.travelInTotalDuration.split(":")[0]}
              </TableCell>
              <TableCell align="right">
                {data.travelInTotalDuration.split(":")[1]}
              </TableCell>
              <TableCell align="right">
                {data.travelInMinRate.toFixed(2)}
              </TableCell>
              <TableCell align="right">
                {data.totalTravelInAmount.toFixed(2)}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell component="th" scope="row">
                Travel Outward charges
              </TableCell>
              <TableCell align="right">
                {data.travelOutTotalDuration.split(":")[0]}
              </TableCell>
              <TableCell align="right">
                {data.travelOutTotalDuration.split(":")[1]}
              </TableCell>
              <TableCell align="right">
                {data.travelOutMinRate.toFixed(2)}
              </TableCell>
              <TableCell align="right">
                {data.totalTravelOutAmount.toFixed(2)}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell component="th" scope="row">
                Waiting time
              </TableCell>
              <TableCell align="right">
                {data.waitingTotalDuration.split(":")[0]}
              </TableCell>
              <TableCell align="right">
                {data.waitingTotalDuration.split(":")[1]}
              </TableCell>
              <TableCell align="right">
                {data.waitingMinRate.toFixed(2)}
              </TableCell>
              <TableCell align="right">
                {data.totalWaitingAmount.toFixed(2)}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell component="th" scope="row">
                Parking
              </TableCell>
              <TableCell align="right" colSpan={3}>
                As per evidance
              </TableCell>
              <TableCell align="right">{data.parking.toFixed(2)}</TableCell>
            </TableRow>

            <TableRow>
              <TableCell component="th" scope="row">
                Mileage
              </TableCell>
              <TableCell align="right" colSpan={2}>
                {data.mileage}
              </TableCell>
              <TableCell align="right">
                {data.mileageMinRate.toFixed(2)}p
              </TableCell>
              <TableCell align="right">
                {data.totalMileageAmount.toFixed(2)}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell component="th" scope="row">
                Travel fares
              </TableCell>
              <TableCell align="right" colSpan={3}>
                As per evidance
              </TableCell>
              <TableCell align="right">{data.travelFares.toFixed(2)}</TableCell>
            </TableRow>

            {/* CHANGES START HERE */}

            <TableRow>
              <TableCell component="th" scope="row">
                Gross Amount
              </TableCell>
              <TableCell align="right" colSpan={4}>
                {(data.grossAmount || data.total || 0).toFixed(2)}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell component="th" scope="row">
                VAT Amount
              </TableCell>
              <TableCell align="right" colSpan={4}>
                {(data.vatAmount || 0).toFixed(2)}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell component="th" scope="row">
                <strong>Total Amount</strong>
              </TableCell>
              <TableCell align="right" colSpan={4}>
                {(data.total || 0).toFixed(2)}
              </TableCell>
            </TableRow>

            {/* CHANGES END HERE */}

            {/* <TableRow>
              <TableCell component="th" scope="row">
                <strong>Total</strong>
              </TableCell>
              <TableCell align="right" colSpan={4}>
                {data.totalAmount.toFixed(2)}
              </TableCell>
            </TableRow> */}
            {customerInvoice && (
              <>
                <TableRow>
                  <TableCell component="th" scope="row">
                    Discounts
                  </TableCell>
                  <TableCell align="right" colSpan={4}>
                    {/* {data.discounts.toFixed(2)} */}
                    {isEdit ? (
                      <IconButton
                        aria-label="edit"
                        style={{ marginRight: "16px" }}
                        size="small"
                        onClick={toEditHandler}
                      >
                        <EditIcon fontSize="inherit" />
                      </IconButton>
                    ) : (
                      <IconButton
                        aria-label="edit"
                        style={{ marginRight: "16px", marginTop: "12px" }}
                        size="small"
                        onClick={handleSubmit(onSubmit)}
                        color="primary"
                      >
                        <SaveIcon fontSize="inherit" />
                      </IconButton>
                    )}
                    {isEdit ? (
                      data.discounts.toFixed(2)
                    ) : (
                      <TextField
                        label="Amount"
                        size="small"
                        fullWidth
                        variant="filled"
                        type="number"
                        name="discounts"
                        inputRef={register}
                        defaultValue={data?.discounts || 0}
                        style={{ width: "80px" }}
                      />
                    )}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell component="th" scope="row">
                    <strong>Sub Total</strong>
                  </TableCell>
                  <TableCell align="right" colSpan={4}>
                    {/* {data.subTotal.toFixed(2)} */}
                    <input
                      type="text"
                      className={classes.borderLess}
                      name="subTotal"
                      ref={register}
                      value={subTotalAmount().toFixed(2)}
                      readOnly
                    />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell component="th" scope="row">
                    {serviceLabel}
                  </TableCell>
                  <TableCell align="right" colSpan={3}>
                    @{data.adminPercent}%
                  </TableCell>
                  <TableCell align="right">
                    {/* {data.adminCharges.toFixed(2)} */}
                    <input
                      type="text"
                      className={classes.borderLess}
                      name="adminCharges"
                      ref={register}
                      value={totalPercentage().toFixed(2)}
                      readOnly
                    />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell component="th" scope="row">
                    <strong>Invoice Total</strong>
                  </TableCell>
                  <TableCell align="right" colSpan={4}>
                    <input
                      type="text"
                      className={classes.borderLess}
                      name="invTotal"
                      ref={register}
                      value={invTotal()}
                      readOnly
                    />
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell component="th" scope="row">
                    Advance / Others
                  </TableCell>
                  <TableCell align="right" colSpan={4}>
                    {data.advancePayment.toFixed(2)}
                  </TableCell>
                </TableRow>

                <TableRow>
                  <TableCell component="th" scope="row">
                    <strong>Amount Due</strong>
                  </TableCell>
                  <TableCell align="right" colSpan={4}>
                    {/* {data.grossTotal.toFixed(2)} */}
                    <input
                      type="text"
                      className={classes.borderLess}
                      name="grossTotal"
                      ref={register}
                      value={dueTotal().toFixed(2)}
                      readOnly
                    />
                  </TableCell>
                </TableRow>
              </>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

Onsite.propTypes = {
  customerInvoice: PropTypes.bool.isRequired,
  data: PropTypes.object.isRequired,
  header: PropTypes.string.isRequired,
};

export default Onsite;
